import React, { FunctionComponent } from 'react';
import { SanityVideo } from '../../../types/common';
import ReadMore from '../../ReadMore';
import RichText from '../../RichText';
import Video from '../../Video';

type VideoCardProps = {
  data: {
    video: {
      video: SanityVideo;
      title: string;
      description: any;
    }
  };
}

const VideoCard: FunctionComponent<VideoCardProps> = ({ data }) => {
  const videoData = data.video;

  return (
    <div
      className='card'
    >
      <Video data={videoData.video} />
      <p><strong className='card-title'>{videoData.title}</strong></p>
      <ReadMore>
        <div className='card-description'>
          <RichText value={videoData.description} />
        </div>
      </ReadMore>
    </div>
  );
}

export default VideoCard;
